import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { thunk } from 'redux-thunk';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';

import filter from './reducers/filter';
import app from './reducers/app';
import accessibility from './reducers/accessibility';
import navigation from './reducers/navigation';
import search from './reducers/search';
import token from './reducers/token';
import transition from './reducers/transition';

const middleware = [thunk];

// Persist accessibility state from local storage
const accessibilityPersistConfig = {
  key: 'accessibility',
  storage,
  whitelist: ['defaultTheme', 'baseFontSize']
};

// Persist token state from local storage
const tokenPersistConfig = {
  key: 'token',
  storage,
  whitelist: ['loggedIn', 'id']
};

const rootReducer = combineReducers({
  accessibility: persistReducer(accessibilityPersistConfig, accessibility),
  token: persistReducer(tokenPersistConfig, token),
  filter,
  app,
  transition,
  navigation,
  search
});

const hydrationProxyReducer = (state, action) => {
  if (action.type === HYDRATE) {
    const mergedCSRandSSRState = {
      ...state, // use current client side state
      ...action.payload // update state with ssr state
    };

    return mergedCSRandSSRState;
  }

  return rootReducer(state, action);
};

// TODO: FIXME: createStore is deprecated. modernize this! (there are probably better ways to setup redux than this approach … or can we remove redux entirely?)
const makeStore = () => {
  return createStore(
    hydrationProxyReducer,
    // initialState is omitted here
    composeWithDevTools(applyMiddleware(...middleware))
  );
};

export const wrapper = createWrapper(makeStore);
